/* browser */
export const SAVE_ITEMS = 'saveSelectedItems'
export const DESTROY_ITEMS = 'destroyAllItems'
export const DESTROY_ITEM = 'destroySelectedItem'
export const REORDER_ITEMS = 'reorderSelectedItems'
export const UPDATE_BROWSER_MAX = 'updateBrowserMax'
export const UPDATE_BROWSER_TITLE = 'updateBrowserTitle'
export const UPDATE_BROWSER_NOTE = 'updateBrowserNote'
export const UPDATE_BROWSER_CONNECTOR = 'updateBrowserConnector'
export const DESTROY_BROWSER_CONNECTOR = 'destroyBrowserConnector'
export const UPDATE_BROWSER_ENDPOINT = 'updateBrowserEndpoint'
export const UPDATE_BROWSER_ENDPOINTS = 'updateBrowserEndpoints'
export const DESTROY_BROWSER_ENDPOINT = 'destroyBrowserEndpoint'
export const DESTROY_BROWSER_ENDPOINTS = 'destroyBrowserEndpoints'
export const ADD_BROWSERS = 'addBrowsers'

export default {
  SAVE_ITEMS,
  DESTROY_ITEMS,
  DESTROY_ITEM,
  REORDER_ITEMS,
  UPDATE_BROWSER_MAX,
  UPDATE_BROWSER_TITLE,
  UPDATE_BROWSER_NOTE,
  UPDATE_BROWSER_CONNECTOR,
  DESTROY_BROWSER_CONNECTOR,
  UPDATE_BROWSER_ENDPOINT,
  DESTROY_BROWSER_ENDPOINT,
  UPDATE_BROWSER_ENDPOINTS,
  DESTROY_BROWSER_ENDPOINTS,
  ADD_BROWSERS
}
